import { render, staticRenderFns } from "./ColorTiles.vue?vue&type=template&id=a404a2b6&scoped=true"
import script from "./ColorTiles.vue?vue&type=script&lang=js"
export * from "./ColorTiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a404a2b6",
  null
  
)

export default component.exports